import { Modal } from 'reactstrap';
import styles from './GstOtpModal.module.scss'
import { OtpField } from '../../../Finance/components/OtpField/OtpField';
import { Field, Form, } from 'react-final-form';
import { values } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import MeritoButton from '../../../../components/common/MeritoButtons/MeritoButtons';
import MeritoCheckbox from '../../../Finance/components/CustomCheckbox/MeritoCheckbox';
import { RestS } from '../../../../rest/rest-service';
import { FORM_ERROR } from 'final-form'
import { LendingJobType } from '../../../../interfaces/interfaces';
import { v1 as uuidv1 } from "uuid";


type Props = {
  isOpen: boolean;
  handleModalClose: () => void;
  onVerify: (values) => void;
  formDetails: {
    gstin: string,
    username: string,
    statementJobId: string,
    formType: LendingJobType,
    formId: number,
    monthYear: string,
    fieldName: string
  },
  onResendOtp: () => void;
}

const GstOtpModal = ({ isOpen, handleModalClose, onVerify, formDetails, onResendOtp }: Props) => {
  const [seconds, setSeconds] = useState(30)
  const [disabled, setDisabled] = useState(true);
  const [loading, setLoading] = useState(false)

  const startTimer = useCallback(() => {
    setDisabled(true)
    setSeconds(30)
  }, [])

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        startTimer();
        const firstOtpBoxElement = document.querySelector('.otpInputBoxFirst');
        // console.log('firstOtpBoxElement', firstOtpBoxElement)
        if (firstOtpBoxElement) {
          (firstOtpBoxElement as HTMLInputElement).focus();
        }
      }, 0)
    }
  }, [isOpen]);

  useEffect(() => {
    if (!disabled) return
    const id = window.setInterval(() => {
      setSeconds((s) => {
        if (s <= 1) {
          clearInterval(id)
          setDisabled(false)
          return 0
        }
        return s - 1
      })
    }, 1000)
    return () => clearInterval(id)
  }, [disabled]);

  const handleResend = () => {
    onResendOtp()
    startTimer()
  }

  const validateOtp = async (values: any) => {
    try {
      // remove commas from the otp value
      setLoading(true)
      const otp = values?.otp?.toString().trim().replace(/,/g, '');
      // const otp = values?.otp?.toString().trim().replace('');
      const statementJobId = formDetails?.monthYear ? `${formDetails?.monthYear}_${uuidv1()}` : uuidv1();
      const body = {
        gstin: formDetails.gstin,
        username: formDetails.username,
        otp: otp,
        taskId: statementJobId,
        formType: formDetails.formType,
        formId: formDetails.formId,
        formFieldName: formDetails.fieldName,
      }
      // console.log('body', body)
      const response: any = await RestS.validateOtp(body);
      if (response?.success) {
        onVerify({
          jobId: response?.jobId,
          statementJobId: statementJobId,
        });
      } else {
        const message = response?.message;
        setDisabled(false)

        if (message == "API Access/GSTIN Username Error") {
          return {
            "otp": "API Access/GSTIN Username Error"
          }
        } else if (message == "GSTIN OTP Expired") {
          return {
            "otp": "GSTIN OTP Expired"
          }
        } else {
          return {
            'otp': message ? message : "Technical Error. Please try again."
          }
        }
      }
    } catch (error) {
      console.log('error', error);
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      toggle={handleModalClose}
      size='md'
      centered
      contentClassName={"bulk_edit_modal"}
    >
      <Form
        onSubmit={async (values) => {
          const errors = await validateOtp(values)
          // console.log('errors', errors)
          if (errors) {
            return errors;
          }
        }}
        render={({ handleSubmit, form, values, pristine, hasValidationErrors }) => {
          // console.log('pristine', pristine)
          return (

            <div className={styles.otpModalRootContainer}>
              <div className={styles.headerContainer}>
                Enter Verification Code
              </div>
              <div className={styles.bodyContainer}>
                <div className={styles.subText}>
                  An OTP has been sent by the GST portal to the registered contact.
                </div>
                <div className={styles.fieldContainer}>
                  <div className={styles.label}>
                    GSTIN
                  </div>
                  <div className={styles.value}>
                    {formDetails.gstin}
                  </div>
                </div>
                <div className={styles.fieldContainer}>
                  <div className={styles.label}>
                    Username
                  </div>
                  <div className={styles.value}>
                    {formDetails.username}
                  </div>
                </div>
                <div className={styles.otpFieldRootContainer}>
                  <Field validate={(values) => {
                    // console.log('values', values)
                    if (!values) {
                      return `Enter OTP`
                    } else if (values?.length && values?.filter((v) => v ? true : false).length < 6) {
                      return `Enter OTP`
                    } else {
                      return ''
                    }
                  }} name={`otp`}>
                    {(props) => {
                      // console.log('props', props)
                      // const showError = props.meta.error || (props.meta.submitError && !props.meta.dirtySinceLastSubmit)
                      return (
                        <OtpField
                          {...props.input}
                          value={props.input.value}
                          onChange={(values) => {
                            props.input.onChange(values)
                            if (values?.length && values?.filter((v) => v ? true : false).length) {
                              // form.resetFieldState('otp')
                              form.resetFieldState('otp')
                            }
                          }}
                          error={props.meta.error || props.meta.submitError}
                          touched={props.meta.touched}
                          length={6}
                        />
                      )
                    }}
                  </Field>

                  <div className={styles.resendOtpContainer}>
                    <div className={styles.resendOtpText}>
                      Didn't receive the code?
                    </div>
                    <div className={`${styles.resendOtpButton} ${!disabled ? styles.enable : ''}`} onClick={() => {
                      if (!disabled) {
                        handleResend()
                        form.resetFieldState('otp')
                        form.change('otp', '')
                      }
                    }}>
                      <span className={styles.resendBtn}>Resend</span> {disabled ? <span className={styles.timeText}> {`in 00:${seconds.toString().padStart(2, '0')}`}</span> : null}
                    </div>
                  </div>
                </div>
                <div className={styles.checkBoxContainer}>
                  <Field validate={(value) => {
                    if (!value) {
                      return `Select an option`
                    }
                    return ''
                  }} name='apiEnabled'>
                    {({ input }) => (
                      <div className={styles.checkboxItemContiner}>
                        <MeritoCheckbox
                          {...input}
                          size='md2'
                          value={input.value}
                          onChange={input.onChange}
                          error={input.error}
                          showError={false}
                          touched={input.touched}
                        />
                        <div className={styles.checkboxLabel}>
                          API access is enabled for this GSTIN.
                        </div>
                      </div>
                    )}
                  </Field>
                </div>

                <div className={styles.bottomBtnContainer}>
                  <MeritoButton
                    type='primary-1'
                    size='lg'
                    isRounded={true}
                    loading={loading}
                    btnText={"Verify"}
                    disabled={pristine || hasValidationErrors}
                    onClick={handleSubmit}
                  />
                </div>
              </div>
            </div>
          )
        }
        }
      >
      </Form>
    </Modal>
  );
}

export default GstOtpModal;